import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {request} from '@/lib/request'
  import {onMounted, onUnmounted, ref} from 'vue'
  import {useStore} from 'vuex'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'SpriteSource',
  props: {
    url: null
  },
  setup(__props: any) {

const props = __props as {
    url: string
  };

  /**
   * An inline svg sprite source
   */

  const store = useStore()

  const root = ref(null)

  

  onMounted(() => {
    const el = root.value
    const url = props.url
    const method = 'GET'

    store.commit('REQUEST_AJAX')

    request({method, url})
      .then((xhr) => {
        const div = document.createElement('div')

        div.innerHTML = xhr.responseText
        div.style.display = 'none'

        el.appendChild(div)
      })
      .finally(() => {
        store.commit('REQUESTED_AJAX')
      })
  })

  onUnmounted(() => {
    const el = root.value

    el.removeChild(el.children[0])
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref_key: "root",
    ref: root,
    class: "sprite-source"
  }, null, 512))
}
}

})